module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list.bc4929f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list.png
// module id = pNKp
// module chunks = 18